(() => {
  const elementName = 'lc-product-complementary-recommendations';
  const trackingScriptSelector = 'script[src*="/lc-product-discovery.js"]';

  if (customElements.get(elementName)) return;

  const requestTrackingInitialization = component => {
    component.dispatchEvent(new CustomEvent('lc:product-discovery:load', {
      bubbles: true
    }));
  };

  const ensureTracking = component => {
    const existingScript = document.querySelector(trackingScriptSelector);

    if (existingScript) {
      if (existingScript.dataset.lcProductDiscoveryReady === 'true') {
        requestTrackingInitialization(component);
      } else {
        existingScript.addEventListener('load', () => {
          requestTrackingInitialization(component);
        }, { once: true });
      }

      return;
    }

    const trackingSource = component.dataset.trackingSrc;
    if (!trackingSource) return;

    const script = document.createElement('script');
    script.src = trackingSource;
    script.defer = true;
    script.addEventListener('load', () => {
      requestTrackingInitialization(component);
    }, { once: true });
    document.head.append(script);
  };

  class ProductComplementaryRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true' || !this.dataset.url) return;

      this.dataset.initialized = 'true';

      if (!('IntersectionObserver' in window)) {
        this.loadRecommendations();
        return;
      }

      const observer = new IntersectionObserver((entries, activeObserver) => {
        if (!entries[0].isIntersecting) return;

        activeObserver.unobserve(this);
        this.loadRecommendations();
      }, { rootMargin: '0px 0px 200px 0px' });

      observer.observe(this);
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then(response => {
          if (!response.ok) throw new Error('Complementary recommendations unavailable');
          return response.text();
        })
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector(elementName);

          if (!recommendations || !recommendations.innerHTML.trim()) {
            this.remove();
            return;
          }

          this.innerHTML = recommendations.innerHTML;
          this.removeAttribute('data-url');
          this.dataset.loaded = 'true';
          ensureTracking(this);
        })
        .catch(() => {
          this.remove();
        });
    }
  }

  customElements.define(elementName, ProductComplementaryRecommendations);
})();
